<template>
  <div class="cont">
    <transition name="fade">
      <div class="book-box" v-if="loaded">
        <div class="topbar row" v-show="view === 'book'" v-if="data.moduleData.topbar">
          <div class="clientLogo">
            <img :src="data.moduleData.topbar.data.clientCustomLogo" />
          </div>
          <div class="topbar-adv row">
            <a v-for="item in data.moduleData.topbar.data.clientTopImage" :href="item.link" :key="item.id"
              target='_blank'>
              <img :src="item.image" />
            </a>
          </div>
        </div>
        <div class="leftbar" v-show="view === 'book'">
          <div class="leftbar-logo">
            <a :href="data.moduleData.logo.data.link" target="_blank">
              <img :src="data.moduleData.logo.data.image" />
            </a>
          </div>
          <div class="leftbar-search" @click="showModule('search', true)"></div>
          <left-menu :menuData="data.leftMenuData"></left-menu>
          <old-magazine></old-magazine>
        </div>
        <div class="left-arrow" @click="prevPage" v-show="view === 'book' & !isHome"></div>
        <div class="right-arrow" @click="nextPage" v-show="view === 'book' & !isLast"></div>
        <transition name="fade">
          <swiper ref="mySwiper" :options="swiperOptions" class="swiper" :style="{
            height: `${height}px`, width: `${width}px`,
            top: `${marginHeight}px`, left: `${marginWidth}px`
          }" v-show="view === 'book'">
            <swiper-slide class="swiper-slide swiper-no-swiping" v-for="(slide, index) in virtualData.slides"
            :key="index"
              :style="{ left: `${virtualData.offset}px` }" style="color:white">
              <div class="left-page">
                <page class='pageImg' v-if='slide.leftPage' :data="slide.leftPage" @click.native="zoom(1)">
                </page>
              </div>
              <div class="right-page">
                <page class='pageImg' v-if='slide.rightPage' :data="slide.rightPage" @click.native="zoom(0)"></page>
              </div>
            </swiper-slide>
          </swiper>
        </transition>
        <div class="rightbar" v-show="view === 'book'">
          <div class="right-adv column">
            <a v-for="item in data.rightAds" :href="item.link" :key="item.id" target='_blank'>
              <img :src="item.image" />
            </a>
          </div>
        </div>
      </div>
    </transition>
    <zoom-view :srcList="data.page" :zoom_visible="view === 'zoom'" :ref="'zoomView'" :zoomPage="zoomPage"></zoom-view>
    <thumb-view :srcList="this.data.pageData" :thumb_visible="view === 'thumb'"></thumb-view>
    <search-view :search_visible="view === 'search'"></search-view>
    <help-view :help_visible="view === 'help'"></help-view>
    <print-view :print_visible="view === 'print'" :pages='data.pageData[data.currentPage]'></print-view>
    <div class="toplayer" v-if="apv">
      <div class="toplayer-nav" @click="apv = false">X</div>
      <iframe frameborder="0" height="600px" width="100%" scrolling="no"
        src="http://www.ar720.cn/web3d/machine_longhua/machine-001-v2/index.html">
      </iframe>
    </div>
    <modal v-if='modal.show'>
    </modal>
    <div class="navbar" v-if="view === 'book'">
      <news-ticker class="navbar-info"></news-ticker>
      <div class="navbar-box">
        <nav-control :total-page='data.totalPage' :pageData='data.pageData' ref="navControl"></nav-control>
        <div class="navbar-box-middle"></div>
        <div class="navbar-box-menu">
          <nav-menu :menu-list='data.menuData' @showModuleEvent="showModule"></nav-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Page from '@/components/page.vue';
import navControl from '@/components/navControl.vue';
import navMenu from '@/components/navMenu.vue';
import modal from '@/components/modal.vue';
import zoomView from '@/components/zoomView.vue';
import thumbView from '@/components/thumbView.vue';
import oldMagazine from '@/components/oldMagazine.vue';
import searchView from '@/components/searchView.vue';
import printView from '@/components/printView.vue';
import helpView from '@/components/helpView.vue';
import leftMenu from '@/components/leftMenu.vue';
import newsTicker from '@/components/newsTicker.vue';
import {
  getModule,
  getPages,
  getLinks,
  getCategoryJson,
  getCategory,
  getRightAds,
} from '@/api/index';
import dataParse from '@/api/parse';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { mapState } from 'vuex';
// import axios from 'axios';
// import Qs from 'qs';
import Cookies from 'js-cookie';

export default {
  name: 'carrousel',
  code: '',
  data() {
    return {
      moduleShow: {
        thumb: false,
        zoom: false,
        search: false,
        help: false,
        print: false,
      },
      zoomPage: 0,
      book: false,
      loaded: false,
      loadPercent: 0,
      large: [],
      thumb: [],
      slideSpeed: 1000,
      data: {
        moduleData: [],
        menuData: [],
        linkData: [],
        rightAds: [],
        currentPage: null,
        totalPage: 100,
        language: 'cn',
        pageData: [],
        page: [],
        pageArr: [],
        settingData: {
          PaperWidth_Thumb: 100,
          PaperHeight_Thumb: 132,
          PaperWidth_Small: 530,
          PaperHeight_Small: 800,
          PaperWidth_Large: 1200,
          PaperHeight_Large: 1589,
        },
      },
      virtualData: {
        slides: [],
      },
      adv: false,
      apv: false,
      swiperOptions: {
        height: '100%',
        lazy: true,
        // autoHeight: true,
        // direction: 'vertical',
        setWrapperSize: true,
        roundLengths: true,
        pagination: {
          el: '.swiper-pagination',
        }, // Some Swiper option/callback...
      },
      screenHeight: 0,
      screenWidth: 0,
    };
  },
  mounted() {
    // this.data.pageData.
    /* eslint-disable */
    if (this.$route.query.code) {
      this.code = this.$route.query.code;
      console.log(this.code)
    } else {
      this.code = window.code;
    }
    if (window.preview) {
      this.$store.state.token = Cookies.get("mlb_hash");
    }
    if (window.lang) {
      this.$store.state.language = window.lang;
    }
    //this.$store.state.language = 'en';
    /*axios.post("http://api.mulubao.com/mulubao_json.php",{
        m:'link',
        catalogid:this.code},{
        headers:{'Content-Type': 'application/x-www-form-urlencoded'},
        withCredentials:true,
        transformRequest:(data)=>{
            return Qs.stringify(data)
        }
    })*/
    this.$store.state.code = this.code;
    this.pagenumber = this.$route.query.pagenumber;
    if (!this.code) {
      console.log("出错了");
    } else if (window.companyid) {
      //预览
      this.$store.state.company_id = window.companyid;
      this.mulubaoCategoryId = this.code;
      this.loadData();
    } else {
      this.loadJson();
    }

    const that = this;
    window.onresize = () => {
      return (() => {

        that.onResize()
      })();
    };
    this.onResize()
    document.addEventListener("keydown", (e) => {
      switch (e.keyCode) {
        case 32:
          e.preventDefault();
          if (this.view === "book") {
            this.zoom(1);
          } else if (this.view === "zoom") {
            this.$store.commit("updateView", {
              view: "book",
            });
          }
          break;
        case 37:
          e.preventDefault();
          if (this.view === "book") {
            this.prevPage();
          } else if (this.view === "zoom") {
            this.$refs.zoomView.prevPage();
          }
          break;
        case 39:
          e.preventDefault();
          if (this.view === "book") {
            this.nextPage();
          } else if (this.view === "zoom") {
            this.$refs.zoomView.nextPage();
          }
          break;
        default:
      }
      // 下面可以通过keyCode来添加键盘事件
    });
  },
  watch: {
    "$store.state.currentPage": function (val) {
      if (val !== this.currentPage) {
        if (this.$refs.mySwiper) this.$refs.mySwiper.$swiper.slideTo(val, this.slideSpeed);
        this.slideSpeed = 1000
        this.$store.commit("updateCurrentPageId", {
          currentPageId: this.getIdByPage(val),
        });
        this.$store.state.currentPageIds = this.data.pageArr[val]
      }
    },
    "$store.state.currentPageId": function (val) {
      if (!val) return false;
      const index = this.getPageById(val);
      if (index !== -1 && index !== this.currentPage) {
        const n = Math.ceil(Number(index) / 2, 0);
        this.$store.commit("updateCurrentPage", {
          currentPage: n,
        });
      }
    },
    screenHeight(val) {

    },
  },
  computed: {
    ...mapState({
      view: (state) => state.view,
      modal: (state) => state.modal,
      height: (state) => state.pageHeight,
      width: (state) => state.pageWidth,
      marginHeight: (state) => state.marginHeight,
      marginWidth: (state) => state.marginWidth,
    }),
    isHome() {
      return this.data.currentPage === 0;
    },
    isLast() {
      return this.data.currentPage === this.data.totalPage - 1;
    },
  },
  methods: {
    nextPage() {
      this.$refs.navControl.nextPage();
    },
    prevPage() {
      this.$refs.navControl.prevPage();
    },
    goPage(page) {
      if (!page || page === 1) return;
      const n = Math.floor(page / 2);
      if (n < this.data.totalPage && n > -1) {
        this.slideSpeed = 0
        this.$nextTick(function () {
          this.$refs.navControl.goPage(n);
        });
      }
    },
    async loadJson() {
      const catalog_json_file = "mulubao_json.php?code=" + this.code;
      this.loadPercent = 0;
      await getCategoryJson(catalog_json_file).then((res) => {
        this.loadPercent += 25;
        this.$store.commit("updateLoadingStatus", {
          mainLoad: { isLoading: true, loadPercent: this.loadPercent },
        });
        this.jsonArray = res;
      });
      this.category_id = this.jsonArray["category_id"]
        ? this.jsonArray["category_id"]
        : this.jsonArray["company_id"] + "_";
      this.mulubaoCategoryId = this.jsonArray["code"];
      this.$store.state.code = this.mulubaoCategoryId;
      this.$store.state.company_id = this.jsonArray["company_id"];
      this.loadData();
    },
    loadData() {
      getLinks(this.mulubaoCategoryId).then((links) => {
        this.loadPercent += 25;
        this.$store.commit("updateLoadingStatus", {
          mainLoad: { isLoading: true, loadPercent: this.loadPercent },
        });
        dataParse.data.linkData = true;
        this.data.linkData = links;
        //this.data.linkData[0].linktype = "modal";
        //this.data.linkData[0].url =
        //  "http://www.ar720.cn/web3d/machine_longhua/machine-001-v2/index.html";
        getPages(this.mulubaoCategoryId).then((res) => {
          this.loadPercent += 25;
          this.$store.commit("updateLoadingStatus", {
            mainLoad: { isLoading: true, loadPercent: this.loadPercent },
          });
          this.data.page = res;
          const pages = this.data.page.map(p => p.pageid)
          pages.unshift('home')
          for (var i = 0; i < pages.length; i += 2) {
            this.data.pageArr.push(pages.slice(i, i + 2));
          }
          const arr = this.data.page.map((element) => {
            element.links = this.data.linkData.filter((item) => {
              return item.pageid === element.pageid;
            });
            return element;
          });
          arr.forEach((element, index) => {
            const i = parseInt(index / 2);
            if (index === 0) {
              let item = {};
              item.rightPage = element;
              this.data.pageData.push(item);
            } else if ((arr.length % 2 == 0) && index === arr.length - 1) {
              let item = {};
              item.leftPage = element;
              this.data.pageData.push(item);
            } else {
              if (index % 2 === 0) {
                if (this.data.pageData[i]) {
                  this.data.pageData[i].rightPage = element;
                } else {
                  let item = {};
                  item.rightPage = element;
                  this.data.pageData.push(item);
                }
              } else {
                let item = {};
                item.leftPage = element;
                this.data.pageData.push(item);
              }
            }
          });

          //this.data.pageData[1].leftPage.links[0].linktype= "modal";
          //this.data.pageData[1].leftPage.links[0].url= "fe15795ef287d7c1e4eb13b6aee22e46_f";
          this.data.totalPage = this.data.pageData.length;
          dataParse.data.pageData = true;
          this.init();
        });
      });
      getModule(this.mulubaoCategoryId).then((res) => {
        this.loadPercent += 25;
        this.$store.commit("updateLoadingStatus", {
          mainLoad: { isLoading: true, loadPercent: this.loadPercent },
        });
        this.data.menuData = res.filter((item) => {
          return item.type === "menu";
        });
        this.data.leftMenuData = res.filter((item) => {
          return item.type === "icon";
        });
        res.forEach((element) => {
          if (element.type === "module") {
            this.data.moduleData[element.name] = element;
          }
        });
        //获取分类广告
        if (this.category_id) {
          getCategory(this.category_id).then((res) => {
            if (res.clienTopImage1) {
              this.data.moduleData["topbar"]["data"]["clientTopImage"][0] = {
                image:
                  "http://ringier.static.mulubao.com/" + res.clienTopImage1,
                link: res.clienTopImage1Url,
              };
            }
            if (res.clienTopImage2) {
              this.data.moduleData["topbar"]["data"]["clientTopImage"][1] = {
                image:
                  "http://ringier.static.mulubao.com/" + res.clienTopImage2,
                link: res.clienTopImage2Url,
              };
            }
          });
        }
        //获取右侧广告
        getRightAds(this.mulubaoCategoryId).then((res) => {
          this.data.rightAds = res
        })
        dataParse.data.moduleData = true;
        this.init();
      });
    },
    getPageById(id) {
      const index = this.data.page.findIndex((element) => {
        return element.pageid === id + "";
      });
      return index;
    },
    getIdByPage(page) {
      let pageid
      if (page === 0) {
        pageid = this.data.page[0]
      } else if (page * 2 >= this.data.page.length) {
        pageid = this.data.page.slice(-1)[0]
      } else {
        pageid = this.data.page[page * 2]
      }
      return pageid.pageid;
    },
    zoom(n) {
      this.zoomPage = this.$store.state.currentPage * 2 - n;
      if (this.zoomPage < 0) this.zoomPage = 0;
      this.showModule("zoom", true);
    },
    init() {
      let self = this;
      if (dataParse.dataLoaded()) {
        this.$store.commit("updateLoadingStatus", {
          mainLoad: { isLoading: true, loadPercent: 100 },
        });
        this.$store.commit("updateCurrentPage", { currentPage: 0 });
        this.$toasted.show("数据加载完成 !!", {
          theme: "toasted-primary",
          position: "top-center",
          duration: 2000,
        });
        self.swiperOptions = {
          height: "100%",
          lazy: { loadPrevNext: false },
          preloadImages: false,
          slideToClickedSlide: true,
          watchSlidesVisibility: false,
          lazyLoading: true,
          setWrapperSize: true,
          roundLengths: true,
          //onlyExternal: true,
          //simulateTouch: false,
          //virtualTranslate:true,
          //effect: "fade",
          // autoHeight: true,
          // direction: 'vertical',
          virtual: {
            slides: self.data.pageData,
            //addSlidesAfter: 1,
            renderExternal(data) {
              // 返回一个经过swiper计算后的当前需要渲染的slides相关信息
              // offset - slides偏移值
              // from - 首个需要渲染的slide索引
              // to - 最后一个需要渲染的slide索引
              // slides - 需要渲染的slides
              self.virtualData = data;
              /*setTimeout(() => {
                self.$refs.mySwiper.$swiper.lazy.load(0);
                self.$refs.mySwiper.$swiper.update();
                self.$forceUpdate();
              }, 1000);*/
            },
          },
          on: {
            slideChange() {
              // 更新index
              console.log("第几页", this.activeIndex);
              self.$store.commit("updateCurrentPage", {
                currentPage: this.activeIndex,
              });
              self.data.currentPage = this.activeIndex;
            },
            slideChangeTransitionEnd: function () { },
            lazyImageLoad: function () { },
          },
          pagination: {
            el: ".swiper-pagination",
          },
        };
        setTimeout(() => {
          this.$store.commit("updateLoadingStatus", {
            mainLoad: { isLoading: false, loadPercent: 100 },
          });
          this.$gtag.pageview('/home')
          this.loaded = true;
          //this.book = true;
          this.$store.commit("updateView", { view: "book" });
          //window.pageNum = 5;
          const pageDefault = window.pageNum ? window.pageNum : 1;
          this.goPage(pageDefault);
        }, 1000);
      } else {
      }
    },
    showModule(name, visible) {
      this.$store.commit("updateView", {
        view: name,
      });
    },
    onKeyUp(e) {

    },
    onResize() {
      window.screenHeight = document.body.clientHeight;
      this.screenHeight = window.screenHeight - 163;
      window.screenWidth = document.body.clientWidth;
      this.screenWidth = window.screenWidth;
      this.$store.state.pageHeight = Math.round(this.screenHeight);
      this.$store.state.pageWidth = Math.round((this.height / 530) * 800);
      let oH = this.$store.state.pageHeight
      let oW = this.$store.state.pageWidth
      if (this.$store.state.pageWidth > 800) {
        oW = 800
      }
      if (this.$store.state.pageHeight > 530) {
        oH = 530
        this.$store.state.marginHeight = 0
      }
      this.$store.state.marginWidth = (this.screenWidth - oW) / 2
      this.$store.state.marginHeight = (this.screenHeight - oH) / 2
    }
  },
  components: {
    Page,
    navControl,
    navMenu,
    Swiper,
    SwiperSlide,
    zoomView,
    thumbView,
    searchView,
    printView,
    oldMagazine,
    helpView,
    modal,
    leftMenu,
    newsTicker,
  },
};
</script>
<style lang="less" scoped>
.book-box {
  width: 100%;
  height: 100%;

  .topbar {
    width: 100%;
    height: 100px;
    background-color: #080e17;
    border-bottom: 1px solid #53555c;

    .clientLogo {
      width: 90px;
      height: 90px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    &-adv {
      text-align: center;
      justify-content: center;
      flex: 1;

      a {
        padding-right: 50px;
      }
    }
  }

  .rightbar {
    position: absolute;
    top: 50%;
    right: 20px;

  }

  .leftbar {
    position: absolute;

    &-logo {
      width: 80px;
      height: 80px;
      margin-top: 20px;
      position: relative;

      img {
        width: 100%;
      }
    }

    &-search {
      margin-top: 20px;
      width: 80px;
      height: 80px;
      background: url("~@/assets/icon/icon_search.png");
      position: relative;
    }

    width: 80px;
    height: 100%;
  }
}

.left-arrow {
  position: absolute;
  top: 50%;
  border-top: 4px solid orange;
  border-left: 4px solid orange;
  transform: rotate(-45deg);
  width: 12px;
  height: 12px;
  left: 50%;
  margin: 0 -450px;
  cursor: pointer;
}

.right-arrow {
  position: absolute;
  border-top: 4px solid orange;
  border-left: 4px solid orange;
  transform: rotate(135deg);
  width: 12px;
  height: 12px;
  top: 50%;
  color: orange;
  left: 50%;
  margin: 0 440px;
  cursor: pointer;
}

.swiper {
  height: 530px;
  max-height: 530px;
  max-width: 800px;
  margin: 0px;
  width: 800px;
  overflow: hidden;
  zoom: 1;
  top: 50%;
  left: 50%;
  position: relative;
  cursor: url("~@/assets/icon/zoomicon.png"), pointer;

  .swiper-slide {
    display: flex;
    flex-basis: auto;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
    //-ms-flex: 0 0 auto;
    //flex-shrink:0;
    position: relative;

    img {
      position: relative;
    }

    .left-page {
      width: 50%;
      margin-left: 0px;
      height: 100%;
      position: relative;

      .btn {
        top: 80px;
        left: 220px;
        width: 150px;
        height: 100px;
        line-height: 100px;
        background: rgba(128, 128, 128, 0.404);
        text-align: center;
        margin-left: 30px;
        margin-top: 30px;
        position: absolute;
        color: wheat;
      }

      .btn:hover {
        background: rgba(245, 245, 245, 0);
        cursor: pointer;
      }

      .video {
        position: absolute;
        bottom: 0;
      }
    }

    .right-page {
      width: 50%;
      margin-left: 0px;
      height: 100%;
      position: relative;

      .video {
        position: absolute;
        bottom: 0;
        right: 0;
      }

      .btn {
        top: 80px;
        left: 220px;
        width: 150px;
        height: 100px;
        line-height: 100px;
        background: rgba(128, 128, 128, 0.404);
        text-align: center;
        margin-left: 30px;
        margin-top: 30px;
        position: absolute;
        color: wheat;
      }

      .btn:hover {
        background: rgba(245, 245, 245, 0);
        cursor: pointer;
      }
    }
  }
}

.cont {
  background: url("~@/assets/bg.jpg");
  width: 100%;
  height: 100%;
  position: absolute;

  .toplayer {
    width: 800px;
    height: 100%;
    z-index: 100;
    position: absolute;
    left: 50%;
    margin: 0 -400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .toplayer-nav {
      background: #f1f1f1;
      width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: right;
      padding-right: 10px;
      box-sizing: border-box;
    }

    .topcont {
      overflow-y: scroll;
      overflow-x: hidden;
      height: 100%;
      width: 100%;
    }
  }

  .navbar {
    width: 100%;
    height: 63px;
    background-color: #080e17;
    bottom: 0;
    position: absolute;
    border-top: 1px solid #53555c;

    .navbar-info {
      height: 30px;
      width: 100%;
    }

    &-box {
      display: flex;
      width: 100%;
      height: 30px;
      background-color: #080e17;
      margin-bottom: 3px;

      &-middle {
        flex-grow: 1;
        flex-basis: auto;
        background: #30353d;
        margin-left: 3px;
      }

      &-menu {
        flex-grow: 0;
        background: #30353d;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>
